export default "__VITE_ASSET__CK296ZF6__"